import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import type { Optional } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  type ApprovalInputArguments,
  optimisticApprovalConfiguration,
} from './helpers'

export const useApproveBranch = (optimisticUserId?: Optional<string>) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      branchKey,
      changesetKey,
      operationKeys,
    }: ApprovalInputArguments) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostApproveBranch(
        {
          requestBody: {
            _type: 'ApproveBranchSpecification',
            branchName: branchKey.name,
            componentName: branchKey.server.toLocaleLowerCase(),
            changesetKey,
            operationKeys,
          },
        },
      )
    },
    ...optimisticApprovalConfiguration({
      optimisticUserId,
      isApproval: true,
      queryClient,
    }),
  })
}
